import { render, staticRenderFns } from "./DocumentPublishValidationModal.vue?vue&type=template&id=33d5a65b"
import script from "./DocumentPublishValidationModal.vue?vue&type=script&lang=ts"
export * from "./DocumentPublishValidationModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports